import React from "react"
import { useNavigate } from "react-router-dom"
import styles from "./backButton.module.css"
import { BsArrowLeft } from "react-icons/bs"

const BackButton = ({
    fallback = "/",
    label = "Voltar",
    className = ""
}) => {
    const navigate = useNavigate()

    const handleBack = () => {
        navigate(fallback)
    }

    return (
        <button
            onClick={handleBack}
            className={`${styles.backButton} ${className}`}
        >
            <BsArrowLeft size={18} />
            <span>{label}</span>
        </button>
    )
}

export default BackButton